import * as React from "react"
const CloseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      fill="#4A4A4A"
      d="M6 0C2.691 0 0 2.691 0 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6Zm2.21 7.502a.5.5 0 1 1-.708.708L6 6.707 4.498 8.21a.498.498 0 0 1-.708 0 .5.5 0 0 1 0-.708L5.293 6 3.79 4.498a.5.5 0 1 1 .708-.708L6 5.293 7.502 3.79a.5.5 0 1 1 .708.708L6.707 6 8.21 7.502Z"
    />
  </svg>
)
export default CloseIcon